import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import commonservice from "@apis/commonservice";
import { uploadAvatar } from "@apis/upload";
import AgencyImg from "@assets/imgs/agency.png";
import CreatorImg from "@assets/imgs/creator.png";
import SellerImg from "@assets/imgs/seller.png";
import AvatarUpload from "@components/AvatarUpload";
import NameInput from "@components/NameInput";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { useLoginHistory } from "@pages/home/login/hooks";
import report from "@report";
import { updateNames, updateUserInfoAvatar } from "@store/globalSlice";
import message from "@utils/message";
import { isInIframe } from "@utils/window";
import { handleUserInfo } from "@layouts/PageSider/AccountDrawer/hooks";
import AccountInformation from "../AccountInformation";
import { useLogout } from "@hooks/account";
import LanguageSelector from "./LanguageSelector";
import { CommonButton } from "@components/CommonButton";
import { Button } from "@kalodata/kds-design";

const Me = () => {
  const { updateAvatarUrl, updateListInfo } = useLoginHistory();
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.globalReducer);
  const [names, setNames] = useState(["", ""]);
  const { logout, loading } = useLogout();

  useEffect(() => {
    setNames([userInfo.firstName || "", userInfo.lastName || ""]);
  }, [userInfo.firstName, userInfo.lastName]);

  const handleAvatarUpload = async (file: File): Promise<string> => {
    try {
      const url = await uploadAvatar(file);
      updateAvatarUrl(userInfo.uid, url);
      dispatch(updateUserInfoAvatar(url));
      message.success("Avatar uploaded successfully");
      return url;
    } catch (error) {
      console.error("头像上传失败:", error);
      message.error("Failed to upload avatar");
      throw error;
    }
  };

  const handleNameMotify = async () => {
    const motifyObj = {
      firstName: names[0],
      lastName: names[1],
    };

    commonservice
      .modifyProfile(motifyObj)
      .then(() => {
        Object.entries(motifyObj).map(([innerkey, innervalue]) => {
          report.click({ kalo_pos: "modifyProfile", kalo_type: innerkey, kalo_value: innervalue });
        });
        updateListInfo(userInfo.uid, {
          username: handleUserInfo({
            firstName: names[0],
            lastName: names[1],
          }),
          firstName: names[0],
          lastName: names[1],
        });
        message.success("Save success");
        dispatch(updateNames(names));
      })
      .catch(() => {
        message.error("Save failure");
        setNames([userInfo.firstName || "", userInfo.lastName || ""]);
      });
  };

  return (
    <div>
      <div className="flex flex-col gap-[16px] border-b border-kds-border pb-[40px]">
        <div className="text-[16px] font-medium">
          <Trans>Profile</Trans>
        </div>
        <div className="flex items-end gap-[16px]">
          <AvatarUpload
            avatarUrl={userInfo.avatarUrl}
            userName={handleUserInfo(userInfo)}
            uploadAction={handleAvatarUpload}
            size={56}
            className="text-[28px]!"
          />
          <div className="flex flex-col gap-[4px]">
            <div className="flex flex-row items-center gap-[16px]">
              <div className="w-[238px] text-[14px] leading-[22px] font-normal">
                <Trans>First Name</Trans>
                <span className="text-kds-danger">*</span>
              </div>
              <div className="w-[238px] text-[14px] leading-[22px] font-normal">
                <Trans>Last Name</Trans>
              </div>
            </div>
            <div className="flex flex-row gap-[16px] items-center">
              <NameInput values={names} setValues={setNames}></NameInput>
              <CommonButton className="h-[40px] min-w-[144px]" onClick={() => handleNameMotify()}>
                <Trans>Update</Trans>
              </CommonButton>
            </div>
          </div>
        </div>
      </div>
      <LanguageSelector></LanguageSelector>
      <AccountInformation />
      <div className="Header">
        <div className="Header-left-wrapper">
          <div className="HeaderInfo_wrapper">
            <div className="Header-Info">
              <div className="name_wrapper">
                <></>
              </div>
            </div>
          </div>
        </div>
        {!isInIframe() && (
          <Button
            className="mt-[40px]"
            variant="outline"
            onClick={() => {
              if (loading) return;
              logout();
            }}
            size="lg"
          >
            <Trans>Log out</Trans>
          </Button>
        )}
      </div>
      <img src={SellerImg} alt="" className="invisible h-0"></img>
      <img src={CreatorImg} alt="" className="invisible h-0"></img>
      <img src={AgencyImg} alt="" className="invisible h-0"></img>
    </div>
  );
};
export default Me;
